<template>
  <main>
    <Hero :prefetch-slides="homePrefetch.banners" :disable-remote-fetch="useAggregateApi" />
    <Solutions v-if="showDataSections" :prefetch-items="homePrefetch.solutions" />
    <Services v-if="showDataSections" :prefetch-items="homePrefetch.products" />
    <Cases v-if="showDataSections" :prefetch-items="homePrefetch.cases" />
    <News v-if="showDataSections" :prefetch-items="homePrefetch.news" />
    <About />
    <Contact />
  </main>
</template>

<script>
import Hero from '../components/Hero.vue'
import Solutions from '../components/Solutions.vue'
import Services from '../components/Services.vue'
import Cases from '../components/Cases.vue'
import News from '../components/News.vue'
import About from '../components/About.vue'
import Contact from '../components/Contact.vue'
import { fetchProductCategories, fetchProductsByCategory } from '../api/products'
import { fetchCaseCategories, fetchCasesByCategory } from '../api/cases'
import { fetchNewsCategories, fetchNewsByCategory } from '../api/news'
import { fetchSolutions } from '../api/solutions'
import { fetchHomeAggregate } from '../api/home'

export default {
  name: 'HomeView',
  data() {
    return {
      showDataSections: false,
      useAggregateApi: true,
      prewarmStarted: false,
      homePrefetch: {
        banners: [],
        solutions: [],
        products: [],
        cases: [],
        news: []
      }
    }
  },
  components: {
    Hero,
    Solutions,
    Services,
    Cases,
    News,
    About,
    Contact
  },
  mounted() {
    const revealDataSections = () => { this.showDataSections = true }
    const prewarmNextPageData = async () => {
      if (this.prewarmStarted) return
      this.prewarmStarted = true
      // 聚合接口完成后，再空闲预热中心页核心接口，提升导航点击响应速度
      const [productCategories, caseCategories, newsCategories] = await Promise.all([
        fetchProductCategories(),
        fetchCaseCategories(),
        fetchNewsCategories()
      ])

      const tasks = [fetchSolutions(), fetchNewsByCategory('all')]

      const firstProductCategory =
        Array.isArray(productCategories) && productCategories.length
          ? productCategories[0]
          : null
      if (firstProductCategory && firstProductCategory.id != null) {
        tasks.push(fetchProductsByCategory(firstProductCategory.id))
      }

      const firstCaseCategory =
        Array.isArray(caseCategories) && caseCategories.length
          ? caseCategories[0]
          : null
      if (firstCaseCategory && firstCaseCategory.id != null) {
        tasks.push(fetchCasesByCategory(firstCaseCategory.id))
      }

      const firstNewsCategory =
        Array.isArray(newsCategories) && newsCategories.length
          ? newsCategories.find((item) => String(item.id) !== 'all') || newsCategories[0]
          : null
      if (firstNewsCategory && firstNewsCategory.id != null) {
        tasks.push(fetchNewsByCategory(firstNewsCategory.id))
      }

      await Promise.allSettled(tasks)
    }
    const schedulePrewarm = () => {
      if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(prewarmNextPageData, { timeout: 1800 })
        return
      }
      setTimeout(prewarmNextPageData, 900)
    }
    const loadHomeAggregate = async () => {
      try {
        const agg = await fetchHomeAggregate()
        if (agg && typeof agg === 'object') {
          this.homePrefetch = {
            banners: Array.isArray(agg.banners) ? agg.banners : [],
            solutions: Array.isArray(agg.solutions) ? agg.solutions : [],
            products: Array.isArray(agg.products) ? agg.products : [],
            cases: Array.isArray(agg.cases) ? agg.cases : [],
            news: Array.isArray(agg.news) ? agg.news : []
          }
        }
      } catch (e) {
        this.useAggregateApi = false
        console.warn('[home] 聚合接口不可用，回退各模块接口', e)
      } finally {
        schedulePrewarm()
        revealDataSections()
      }
    }

    loadHomeAggregate()
  }
}
</script>
